import { render, staticRenderFns } from "./Glm4V.vue?vue&type=template&id=2fe01f32&scoped=true"
import script from "./Glm4V.vue?vue&type=script&lang=js"
export * from "./Glm4V.vue?vue&type=script&lang=js"
import style0 from "./Glm4V.vue?vue&type=style&index=0&id=2fe01f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe01f32",
  null
  
)

export default component.exports